export default {
  plain: {
    color: '#bfc7d5',
    backgroundColor: 'transparent'
  },
  styles: [
    {
      types: ['comment'],
      style: {
        color: 'rgb(105, 112, 152)',
        fontStyle: 'italic'
      }
    },
    {
      types: ['string'],
      style: {
        color: 'rgb(195, 232, 141)'
      }
    },
    {
      types: ['number'],
      style: {
        color: 'rgb(247, 140, 108)'
      }
    },
    {
      types: ['builtin', 'char', 'constant', 'function'],
      style: {
        color: 'rgb(149, 175, 251)'
      }
    },
    {
      types: ['punctuation', 'selector'],
      style: {
        color: 'rgb(149, 175, 251)'
      }
    },
    {
      types: ['variable'],
      style: {
        color: 'rgb(149, 175, 251)'
      }
    },
    {
      types: ['class-name'],
      style: {
        color: 'rgb(199, 146, 234)'
      }
    },
    {
      types: ['attr-name'],
      style: {
        color: '#FFCB6B'
      }
    },
    {
      types: ['attr-value'],
      style: {
        color: 'rgb(199, 146, 234)',
        fontStyle: 'bold'
      }
    },
    {
      types: ['tag'],
      style: {
        color: 'rgb(255, 88, 116) '
      }
    },
    {
      types: ['operator'],
      style: {
        color: 'rgb(137, 221, 255)'
      }
    },
    {
      types: ['boolean'],
      style: {
        color: 'rgb(255, 88, 116)'
      }
    },
    {
      types: ['keyword'],
      style: {
        fontStyle: 'italic'
      }
    },
    {
      types: ['doctype'],
      style: {
        color: 'rgb(199, 146, 234)',
        fontStyle: 'italic'
      }
    },
    {
      types: ['namespace'],
      style: {
        color: 'rgb(178, 204, 214)'
      }
    },
    {
      types: ['url'],
      style: {
        color: 'rgb(221, 221, 221)'
      }
    }
  ]
}
